import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Products";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main role="main" id="main-content">
        <Hero />
        <About />
        <Products />
        <FAQ />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
